module.exports = __webpack_public_path__ + "img/DH splash art.c41ac88b.png";